module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "praise-for-divine-poison"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "praise-for-divine-poison-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise for Divine Poison:")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "praise-for-divine-poison-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("\"")]), _vm._v("T")]), _vm._v("he pace is")]), _vm._v(" great for the plot, which is well thought out and planned thoroughly to give it an added edge...\""), _c('b', [_c('i', [_vm._v("Donna Maguire - Donnas Book "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Blog")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"I would highly recommend this book to so many readers. And I’m definitely going to be reading so much more by this author.\" "), _c('b', [_c('i', [_vm._v("Ami-May Smith - Shyla's Uncensored "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Opinions")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"This story was full of intrigue and mystery that kept me turning page after page."), _c('b', [_vm._v("\" "), _c('i', [_vm._v("Lorna Cassidy - On The Shelf "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Reviews")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"Divine Poison has a tangled web of lies and secrets lurking within the pages along with a few surprises thrown in to make things interesting.\" "), _c('i', [_vm._v("Rachel Broughton - Rae "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Reads")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"DIVINE POISON is thrilling to read and a book to keep you on your toes!\""), _c('b', [_c('i', [_vm._v("Sooz Barthorpe - The P.Turners Book "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Blog")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"Again AB Morgan has used her own career experiences to add her own unique style to this story.\" "), _c('b', [_c('i', [_vm._v("Yvonne Bastian - Me And My "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Books")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11d6f682","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praisefordivinepoison.vue
// module id = 72
// module chunks = 0